import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import TituloComponent from '../../components/Titulo/TituloComponent';
// css
import '../../styles/global.css';
import './BarGerentePage.css';


const BarGerente = () => {
  const navigate = useNavigate();
  
  // Pega os dados da sessão diretamente
  const userData = JSON.parse(sessionStorage.getItem('userData')); // Assume que os dados estão armazenados no sessionStorage
  const statusUsuario = userData?.statusUsuario;
  const nomePerfil = userData?.dadosPerfil?.nome;
  const nomeUsuario = userData?.user.name;

  const [isAuthorized, setIsAuthorized] = useState(true);

  useEffect(() => {
    // Verifica se o usuário tem o perfil correto e está logado
    if (!userData || userData.dadosPerfil?.nome !== 'BAR GERENTE' || userData.statusUsuario !== 'logado') {
      console.log(' !!!! Perfil não autorizado ou usuário não logado. Redirecionando...');
      setIsAuthorized(false); // Atualiza o estado de autorização
      navigate('/area-restrita'); // Redireciona para a página de login ou área restrita
    } else {
      console.log('--- PAGINA BAR GERENTE ---');
      console.log('Dados completos do usuário:', userData);
      console.log('Status do usuário:', statusUsuario);
      console.log('Perfil do usuário:', nomePerfil);
    }
  }, [userData, statusUsuario, nomePerfil, navigate]);

  // Função para fazer o logout
  const handleLogout = () => {
    // Remove os dados da sessão
    sessionStorage.removeItem('userData');
    // Remove todos os dados da sessão
    // sessionStorage.clear();
    // Redireciona para a página de login
    navigate('/area-restrita');
  };

  // Função para redirecionar para DadosDoEstabelecimentoPage
  const handleGoToDadosEstabelecimento = () => {
    navigate('/dados-do-estabelecimento');
  };

  // Função para redirecionar para ProdutosPage
  const handleGoToProdutos = () => {
    navigate('/produtos');
  };

  // Função para redirecionar para Checkins com contas em aberto
  const handleGoToCheckinsAbertos = () => {
    navigate('/checkins-com-contas-em-aberto');
  };

  // Função para redirecionar para geração de qr code para a mesa
  const handleGoToGerarQrCodeMesa = () => {
    navigate('/gerar-qr-code-mesa');
  };

  // Função para redirecionar para visualização de dashboard de mesas abertas
  const handleGoToVisualizarDashboardMesasAbertas = () => {
    navigate('/visualizar-dashboard-mesas-abertas');
  };

  // Função para redirecionar para CadastrarFuncionarioPage
  const handleGoToCadastrarFuncionario = () => {
    navigate('/form-cadastrar-funcionario');
  };

  if (!isAuthorized) {
    return <div>Redirecionando...</div>; // Mostra uma mensagem enquanto redireciona
  }

  return (
    <div autoFocus className="bar-gerente-container">
        <TituloComponent />
        <h1 className="sub-titulo">Área do Gerente</h1>
        
        <div className="box-dados">
            {/* Exibe o nome do perfil do usuário */}
            <p className="texto-welcome">Bem-vindo, {nomeUsuario}!</p>
            {/* Botão de Logout */}
            <button className="welcome-btn" onClick={handleLogout}>Logout</button>
        </div>
        
        {/* Container de quadros */}
        <div className="quadros-container">
            <div className="quadro" onClick={handleGoToDadosEstabelecimento}>
                <h3>Dados do Estabelecimento</h3>
                <p>Edite as informações sobre o seu Estabelecimento.</p>
            </div>
            <div className="quadro" onClick={handleGoToCadastrarFuncionario}>
                <h3>Funcionários</h3>
                <p>Gerencie seus funcionários.</p>
            </div>
            <div className="quadro" onClick={handleGoToProdutos} >
                <h3>Produtos</h3>
                <p>Veja e administre os produtos do seu Estabelecimento.</p>
            </div>
            <div className="quadro" onClick={handleGoToCheckinsAbertos} >
                <h3>Checkins</h3>
                <p>Visualize os checkins com contas em aberto.</p>
            </div>
            <div className="quadro" onClick={handleGoToGerarQrCodeMesa} >
                <h3>Gerar QR Code</h3>
                <p>Gere QR Code para sua mesa.</p>
            </div>
            <div className="quadro" onClick={handleGoToVisualizarDashboardMesasAbertas} >
                <h3>Dashboard mesas abertas</h3>
                <p>Visualize as mesas que estão abertas.</p>
            </div>
            {/* <div className="quadro">
                <h3>Mesas do Estabelecimento</h3>
                <p>Edite as informações sobre as mesas do seu Estabelecimento.</p>
            </div>
            <div className="quadro">
                <h3>Planos</h3>
                <p>Gerencie os planos de serviço oferecidos.</p>
            </div> */}

        </div>
    </div>
  );
};

export default BarGerente;
